import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { MobilityMapFilterKey } from '../../types/mobility-map-filters';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<MobilityMapFilterKey, undefined> {
    public override placeholder = 'Suchbegriff eingeben';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suche', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
